import React, { Component } from 'react';
import { withNamespaces } from "react-i18next";
import { connect } from 'react-redux';
import Swal from "sweetalert2";
import Skeleton from "react-loading-skeleton";
import Slider from "react-slick";
import { Icon } from "@iconify/react";
import { Fade } from "react-awesome-reveal";
import Modal from "react-modal";
import { isDesktop } from 'react-device-detect';
import moment from "moment-timezone";
import Confetti from 'react-confetti';
import Timer from "react-compound-timer";

import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import Button from "../../components/Button/Button";
import MobileFifaWorldCup from './MobileFifaWorldCup';
import LoadingPage from "../../components/LoadingPage/LoadingPage";

import * as actions from "../../store/ducks/fifaWorldCup/actions";

class FifaWorldCup extends Component 
{
    constructor(props) 
    {
        super(props);
        this.state = 
        {
            fistLoading: true,
            loading: true,
            openModal: '',
            preWinCount: 0,
            dropDown:
            {
                dateList: [],
                match: [],
            },
            input:
            {
                date: "",
                slideCount: 0,
                matchArr: [],
                matchBetArr: [],
            },
            totalMatch: [],
        };
        this.onInputChangeHandler = this.onInputChangeHandler.bind(this);
    }

    componentDidMount() 
    {
        this.props.funcGetDropDown(1); // 1 = fifa world cup 2022 league id
    }

    shouldComponentUpdate(nextProps, nextState) 
    {
        const { t } = this.props;
        if (nextProps.listing !== this.props.listing && nextProps.listing !== undefined) 
        {
            if (nextProps.listing.responseCode === 200 && nextProps.listing.msgType === "success") 
            {
                let tmpArr = [];
                let totalMatch = [];
                let totalMatchVal = [];
                let totalMatchCount = [];
                let dateList = [];
                let match = [];
                let dateTime = [];
                let newInput = Object.assign({}, this.state.input);
                let openModal = false;
                let preWinCount = 0;
                let sliderCount = 0;
                const now = moment(moment().format('YYYY-MM-DD h:m:s')).tz("Asia/Kuala_Lumpur");
                
                nextProps.listing.data.match.forEach((val) => 
                {
                    dateTime = val.match_date.split(' ');
                    let momentDateTime = moment(val.match_date).tz("Asia/Kuala_Lumpur");
                    let duration = momentDateTime.diff(now, "milliseconds");
                    let labelDate = dateTime[0].split('-');
                    let labelTime = dateTime[1].split(':');
                    let day = moment(dateTime[0]).format('ddd').toString().toLowerCase();

                    if (tmpArr[dateTime[0]] === undefined) 
                    {
                        dateList.push({
                            name: dateTime[0], 
                            label: `${labelDate[0]}${t('world-cup.year')}${labelDate[1]}${t('world-cup.month')}${labelDate[2]}${t('world-cup.day')}`,
                            status: (duration < 0) ? 'deactive' : ((duration === 0) ? 'active' : 'pending'),  //deactive, active, pending
                            annouce: (duration < 0) ? t('world-cup.end') : ((duration === 0) ? t('world-cup.running') : t('world-cup.early')),
                        });

                        tmpArr[dateTime[0]] = dateTime[0];
                        // newInput["date"] = (duration === 0) ? dateTime[0] : ((this.state.input.date !== '') ? this.state.input.date : ((newInput["date"] === "" && duration > 0) ? dateTime[0] : ''));
                        
                        if(duration === 0)
                        {
                            newInput["date"] = dateTime[0];
                        }
                        else
                        {
                            if(this.state.input.date !== '')
                            {
                                newInput["date"] = this.state.input.date;
                            }
                            else
                            {
                                if(newInput["date"] === "" && duration > 0)
                                {
                                    newInput["date"] = dateTime[0];
                                }
                            }
                        }
                        
                        sliderCount++;
                        if(newInput["date"] !=='' && newInput["date"] === dateTime[0])
                        {
                            newInput["slideCount"] = ((sliderCount - 4) > 0) ? (sliderCount - 4) : 0;
                        }
                    }

                    totalMatchCount[dateTime[0]] = (totalMatchCount[dateTime[0]] === undefined) ? 1 : totalMatchCount[dateTime[0]]+1;
                    totalMatchVal = {
                        count: totalMatchCount[dateTime[0]],
                        disabled: (duration <= 0) ? true : false,
                        totalWinCount: 0,
                        totalWinAmt: 0,
                        slug: val.match_slug,
                    }
                    totalMatch[dateTime[0]] = totalMatchVal;

                    match.push({
                        id: val.id,
                        date: dateTime[0],
                        dateTime: val.match_date,
                        label: `${labelDate[0]}-${labelDate[1]}-${labelDate[2]} ${t(`world-cup.${day}`)} ${labelTime[0]}:${labelTime[1]}`,
                        teamAId: val.team_a_id,
                        teamBId: val.team_b_id,
                        teamA: val.team_a,
                        teamB: val.team_b,
                        teamAScore: val.team_a_score,
                        teamBScore: val.team_b_score,
                        teamAExtraScore: val.team_a_extra_score,
                        teamBExtraScore: val.team_b_extra_score,
                        isExtra: val.is_extra,
                    });
                });
                
                newInput["date"] = (newInput["date"] !== "") ? newInput["date"] : dateTime[0];

                if(nextProps.listing.data.matchBet && nextProps.listing.data.matchBet.length > 0)
                {
                    nextProps.listing.data.matchBet.forEach((val) => 
                    {
                        newInput['matchBetArr'][val.match_id] = val.team_id;
                        totalMatch[val.match_date].disabled = true;
                        if(val.transaction_id !== null && val.transaction_id > 0)
                        {
                            totalMatch[val.match_date].totalWinCount = totalMatch[val.match_date].totalWinCount + 1;
                            totalMatch[val.match_date].totalWinAmt = totalMatch[val.match_date].totalWinAmt + 8;
                            openModal = (nextState.openModal === false) ? false : true;
                            preWinCount = totalMatch[val.match_date].totalWinCount;
                        }
                    });
                }
                // openModal = (nextState.openModal && nextState.openModal !== '') ? false : true;
                // console.log(newInput, totalMatch, dateList, match);
                
                this.setState({
                    openModal,
                    preWinCount,
                    input: newInput,
                    totalMatch,
                    dropDown: 
                    {
                        dateList,
                        match,
                    },
                    loading: false,
                    fistLoading: false,
                });
            }
        }

        if (nextProps.store !== this.props.store && nextProps.store !== undefined) 
        {
            if (nextProps.store.responseCode === 200 && nextProps.store.msgType === "success") 
            {
                Swal.fire({
                    iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/ri:check-fill.svg?color=%2306DB04">' : '',
                    icon: "success",
                    title: t("global.success"),
                    showConfirmButton: true,
                    customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container sucess",
                              icon: "swal-success-icon",
                          }
                        : [],
                }).then(() => 
                {
                    this.props.funcGetDropDown(1);
                });
            }
            else 
            {
                this.swalErrorHandler(nextProps.store.message[0]);
            }
        }

        return true;
    }

    onInputChangeHandler = (event) => 
    {
        // console.log(event.target.name+' | '+event.target.value);
        let matchTeamArr = event.target.value.split('_');
        let newInput = Object.assign({}, this.state.input);
        newInput['matchArr'][matchTeamArr[0]] = matchTeamArr[1];
        // console.log(newInput);

        this.setState({
            input: newInput,
        });
    }

    closeModal = () => 
    {
        this.setState({
            openModal: false,
        });
    }

    imageImport = (r) => 
    {
        let images = {};
        r.keys().map((item) => 
        {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    }

    changeDateHandler = (date) => 
    {
        let input = Object.assign({}, this.state.input);
        input['date'] = date;
        input['matchArr'] = [];

        this.setState({
            input,
            loading: true,
        }, () => 
        {
            // this.props.funcGetDropDown(1);
            this.setState({
                loading: false,
            });
        });
    }

    swalErrorHandler = (msg) => 
    {
        const { t } = this.props;
        Swal.fire({
            iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/mdi:close.svg?color=%23ea4e3d">' : '',
            title: t("global.error"),
            text: msg,
            icon: 'error',
            confirmButtonText: t('global.ok'),
            customClass: (!isDesktop) ? {
            container: "swal-mobile-container failed",
            icon: "swal-failed-icon",
            } : [],
        }).then(() => 
        {
            // let newTab = Object.assign({}, this.state[this.state.historyTab]);
            // newTab['loading'] = false;

            // this.setState({
            //     [this.state.historyTab]: newTab,
            //     disableSearchButton: false,
            // });
            // Swal.close();
        });
    }

    getDuration = (date) => 
    {
        let dateFromApi = `${this.state.input.date} 00:00:00`;
        let createdAt = moment.tz(dateFromApi, "Asia/Kuala_Lumpur");
        let now = moment().tz("Asia/Kuala_Lumpur");
        let duration = createdAt.diff(now, "milliseconds");
        
        return (duration > 0) ? duration : 0;
    }

    submitHandler = (e) => 
	{
		e.preventDefault();
		const { t } = this.props;
        
        let newFilter = Object.assign({}, this.state.input.matchArr);
        let formData = new FormData();
        let totalMatch = 0;

        for (const key in newFilter)
        {
            formData.append('match['+key+']', newFilter[key]);
            totalMatch++;
        }

        if (totalMatch === this.state.totalMatch[this.state.input.date].count)
        {
            Swal.fire({
                iconHtml: (!isDesktop) ? '<img src="https://api.iconify.design/uil:exclamation.svg?color=%23ffa700">' : '',
            	title: t("global.confirmation"),
            	text: t("global.would-you-like-to-proceed") + "?",
            	icon: "warning",
            	showCancelButton: true,
            	confirmButtonText: t("global.save"),
            	cancelButtonText: t("global.cancel"),
                customClass: !isDesktop
                        ? {
                              container: "swal-mobile-container confirmation",
                              icon: "swal-confirmation-icon",
                          }
                        : [],
            }).then((result) => 
            {
            	if (result.isConfirmed) 
            	{
            		Swal.fire({
            			title: "",
            			allowOutsideClick: false,
            			allowEscapeKey: false,
            			allowEnterKey: false,
            			didOpen: () => 
                        {
            				Swal.showLoading();
            			},
            		});
                    
                    formData.append('date', this.state.input.date);
                    // for (var pair of formData.entries()) 
                    // {
                    //     console.log(pair[0]+ ' = ' + pair[1]);
                    // }
                    this.props.funcStore(formData);
            	}
            });
        }
	}

    render() 
    {
        const { t } = this.props;
        const tNc = this.imageImport(require.context("../../assets/images/tnc", false, /\.(png|jpe?g|svg|webp)$/));
        const banner = this.imageImport(require.context("../../assets/images/banners", false, /\.(png|jpe?g|svg|webp)$/));
        // const img = this.imageImport(require.context("../../assets/images/leaderboard", false, /\.(png|jpe?g|svg)$/));
        const image = this.imageImport(require.context("../../assets/images/world-cup", false, /\.(png|jpe?g|svg|webp)$/));
        const flag = this.imageImport(require.context("../../assets/images/world-cup/flag", false, /\.(png|jpe?g|svg|webp)$/));

        let imageLanguage = '';
        switch (this.props.currentUser.language_code) 
        {
            case "zh-CN":
                imageLanguage = "-cn";
            break;
            case "ms":
              imageLanguage = "-bm"
              break;
              case "indon":
                imageLanguage = "-id"
                break;
            default:
                imageLanguage = "";
            break;
        }

        let settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            initialSlide: (this.state.input.slideCount || 0),
            arrows: false,
        };

        let dateList = this.state.dropDown.dateList ? this.state.dropDown.dateList : [];
        let match = this.state.dropDown.match ? this.state.dropDown.match : [];
        let fakeData = [];
        
        if(this.state.totalMatch[this.state.input.date] && this.state.totalMatch[this.state.input.date].count > 0)
        {
            let fakeAmt = 8;
            let fakeCount = (this.state.totalMatch[this.state.input.date].count > 4) ? 4 : this.state.totalMatch[this.state.input.date].count;
            for (let i = 1; i <= fakeCount; i++) 
            {
                fakeData.push(
                <div className={` wc-reward-container col-3`} key={i}>
                    <div className='wc-reward-header'>
                        <h3 className='m-0'>{t('world-cup.modal-msg', {attribute: i})}</h3>
                    </div>
                    <div>
                        <img src={image[`reward-${i}.png`]} alt="reward-1" />
                        <h4>{fakeAmt}</h4>
                    </div>
                </div>);
                fakeAmt = fakeAmt + 8;
            }
        } 

        return (
            <Auxiliary>
                {this.state.fistLoading && <LoadingPage />}
                <Modal
                    isOpen={this.state.openModal}
                    closeTimeoutMS={500}
                    portalClassName={`global-modal wc-modal`}
                    className="modal modal-dialog modal-dialog-centered modal-pd"
                    ariaHideApp={false}
                    onRequestClose={this.closeModal}
                >
                    <div className={`modal-content ${isDesktop ? '' : 'mobile-modal-bg-white p-0'}`}>
                        <div className="modal-body">
                            <div className="ls-modal gap-3">
                                <div>
                                    <img src={image["reward-4.png"]} alt="award" />
                                    <h4>{t('world-cup.congrats-msg')}</h4>
                                    <label>{t('world-cup.congrats-msg-1', {attribute: this.state.preWinCount})}<br />{t('world-cup.congrats-msg-2')}</label>
                                </div>
                                <Button
                                    typeButton="button"
                                    classValue={`btn ${isDesktop ? "btn-gradient-blue" : "btn-white w-100 "}`}
                                    buttonName={t('global.confirm')}
                                    clicked={this.closeModal}
                                />
                            </div>
                            <Confetti
                                width={isDesktop ? 574 : 880}
                                height={isDesktop ? 339 : 448}
                                numberOfPieces={30}
                                opacity={0.3}
                            />
                        </div>
                    </div>
                </Modal>
                {
                    isDesktop ? (
                        <section className='wc-section'>
                            <div className="banner-col">
                                <div className="banner-item">
                                <img src={banner[`world-cup-banner${imageLanguage}.webp`]} alt="R77 Promos" />
                                </div>
                            </div>

                            <div className='x-container'>
                                <div className='section-header-gray'>
                                    <h2>{t('world-cup.title')}</h2>
                                    <p>{t('world-cup.title-1')}</p>
                                </div>
                                <div className='wc-category-cont'>
                                    <div className='slick-container'>
                                        {this.state.fistLoading ? (
                                            <Skeleton count={1} height={40} style={{ marginBottom: "1rem" }} />
                                        ) : (
                                            <Slider ref={c => (this.slider = c)} {...settings}>
                                                {dateList.length > 0 && dateList.map((item, index) => (
                                                    <div className="match-date-btn" key={index}>
                                                    <button type="button"
                                                        className={`lb-game ${this.state.input.date === item.name && 'active'}`}
                                                        onClick={() => this.changeDateHandler(item.name)}
                                                    >
                                                        <h5>{item.label}</h5>
                                                        <p className={`status ${item.status}`}>{item.annouce}</p>
                                                    </button>
                                                    </div>
                                                ))}
                                            </Slider>
                                        )}
                                        <div className="slick-arrow">
                                            <div className="slick-arrow-btn prev" onClick={() => this.slider.slickPrev()}>
                                                <Icon icon="uil:angle-left-b" />
                                            </div>
                                            <div className="slick-arrow-btn next" onClick={() => this.slider.slickNext()}>
                                                <Icon icon="uil:angle-right-b" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='wc-vs-section card-shadow wc-table mt-4'>
                                    <div className='section-header-gray'>
                                        <h3>{t('world-cup.title-2', {attribute: ((this.state.totalMatch[this.state.input.date] && this.state.totalMatch[this.state.input.date].slug && t(`world-cup.${this.state.totalMatch[this.state.input.date].slug}`)) || '')})}</h3>
                                        <p className='event-date'>{t('world-cup.remain-time')}：
                                            {this.state.input.date && this.state.input.date !== '' && !this.state.loading && 
                                                <Timer 
                                                    initialTime={this.getDuration()}
                                                    direction="backward"
                                                    formatValue={(value) => `${(value < 10 ? `0${value}` : value)}`}
                                                >
                                                    <Timer.Days />{t('world-cup.d')} <Timer.Hours />{t('world-cup.h')} <Timer.Minutes />{t('world-cup.m')} <Timer.Seconds />{t('world-cup.s')}
                                                </Timer>
                                            }
                                        </p>
                                        <h4 className='mt-3'>
                                            {this.state.totalMatch[this.state.input.date] && !this.state.totalMatch[this.state.input.date].disabled &&
                                                (<>{t('world-cup.submit-msg', {attribute: (this.state.totalMatch[this.state.input.date] && this.state.totalMatch[this.state.input.date].count) || 0})}</>)
                                            }
                                        </h4>
                                    </div>

                                    <form className="" method="post" id="wc_form" encType='multipart/form-data' onSubmit={this.submitHandler} noValidate>
                                        {match.length > 0 &&
                                        <div className='wc-head row gx-4 gy-4 '>
                                            {match.map((item, index) => 
                                            {
                                                if(item.date === this.state.input.date)
                                                {
                                                    return (
                                                        <div className='wc-body' key={index}>
                                                            <Fade duration={1000} triggerOnce>
                                                                <div className='wc-bg'>
                                                                    <img src={image["world-cup-vs-bg.jpg"]} alt="world cup vs bg" />
                                                                    <div className='wc-content'>
                                                                        <p>{t('world-cup.start-time')}：{item.label}</p>
                                                                        <div className='wc-details'>
                                                                            {/* <div className={`form-check form-check-inline ${item.resultOne}`}> */}
                                                                            <div className={`form-check form-check-inline`}>
                                                                                <input
                                                                                    className="btn-check"
                                                                                    type="radio"
                                                                                    name={`matchOpt${item.teamAId}`}
                                                                                    id={`matchOpt${item.teamAId}`}
                                                                                    value={`${item.id}_${item.teamAId}`}
                                                                                    onChange={
                                                                                        (this.state.totalMatch[this.state.input.date] && !this.state.totalMatch[this.state.input.date].disabled)
                                                                                        ?
                                                                                        (event) => this.onInputChangeHandler(event)
                                                                                        :
                                                                                        null
                                                                                    }
                                                                                    checked={
                                                                                        (this.state.input.matchArr[item.id]
                                                                                        && this.state.input.matchArr[item.id] !== undefined
                                                                                        && Number(this.state.input.matchArr[item.id]) === Number(item.teamAId))
                                                                                        || (Number(this.state.input.matchBetArr[item.id]) === Number(item.teamAId))
                                                                                        ? 
                                                                                        true 
                                                                                        : 
                                                                                        false
                                                                                    }
                                                                                    // disabled={
                                                                                    //     (this.state.input.matchBetArr[item.id] || this.state.totalMatch[this.state.input.date].disabled)
                                                                                    //     ? 
                                                                                    //     true
                                                                                    //     :
                                                                                    //     false
                                                                                    // }
                                                                                />
                                                                                {/* <label className={`btn form-check-label enable / disabled`} htmlFor={item.teamOne}> */}
                                                                                <label className={`btn form-check-label ${(Number(item.teamAScore) < Number(item.teamBScore)) ? 'disabled' : ''}`} htmlFor={`matchOpt${item.teamAId}`}>
                                                                                    <img src={flag[`${item.teamA.toLowerCase()}.svg`]} alt={item.teamA} />
                                                                                    <p>{t(`world-cup.team.${item.teamA.toLowerCase()}`)}</p>
                                                                                </label>
                                                                                {(Number(item.teamAScore) > Number(item.teamBScore))
                                                                                // {((Number(item.teamAScore) > Number(item.teamBScore)) || ((Number(item.teamAExtraScore) > Number(item.teamBExtraScore))))
                                                                                ?
                                                                                    <img className="win-img" src={image["win.png"]} alt={`win${item.teamA}`} />
                                                                                :
                                                                                    null
                                                                                }
                                                                            </div>
                                                                            
                                                                            <div className={(item.teamAScore !== null && item.teamBScore !== null) ? `versus-body` : ''}>
                                                                                {(item.teamAScore !== null && item.teamBScore !== null) 
                                                                                ? 
                                                                                    <>
                                                                                        <span>{t('world-cup.score')}</span>
                                                                                        <span className='score-font'>
                                                                                            {(item.isExtra === 1)
                                                                                            ?
                                                                                            <>{item.teamAExtraScore} - {item.teamBExtraScore} </>
                                                                                            :
                                                                                            <>{item.teamAScore} - {item.teamBScore} </>
                                                                                            }
                                                                                        </span>    
                                                                                        {item.isExtra >= 1 && <span className='aet-font'>({t('world-cup.aet')})</span>}
                                                                                        
                                                                                        {item.isExtra === 2 &&
                                                                                            <><span className='mt-2'>{t('world-cup.penalties')}</span>
                                                                                            <span className='btn-gradient-blue'>{item.teamAExtraScore} - {item.teamBExtraScore}</span>
                                                                                        </>
                                                                                        }
                                                                                        
                                                                                    </>
                                                                                :
                                                                                    <div className={(item.teamAScore !== null && item.teamBScore !== null) ? `mb-3` : ''}>
                                                                                        <img className='versus-img' src={image["versus.png"]} alt="vs" />
                                                                                    </div>
                                                                                }
                                                                            </div>

                                                                            {/* <div className='versus-body'>
                                                                                <span>总得分</span>
                                                                                <span className='score-font'>2 - 2</span>
                                                                                <span className='aet-font'>(a.e.t)</span>
                                                                                <span className='mt-2'>Penalties</span>
                                                                                <span className='btn-gradient-blue'>3 - 2</span>
                                                                            </div> */}
                                                                            
                                                                            <div className={`form-check form-check-inline`}>
                                                                                <input
                                                                                    className="btn-check"
                                                                                    type="radio"
                                                                                    name={`matchOpt${item.teamBId}`}
                                                                                    id={`matchOpt${item.teamBId}`}
                                                                                    value={`${item.id}_${item.teamBId}`}
                                                                                    onChange={
                                                                                        (this.state.totalMatch[this.state.input.date] && !this.state.totalMatch[this.state.input.date].disabled)
                                                                                        ?
                                                                                        (event) => this.onInputChangeHandler(event)
                                                                                        :
                                                                                        null
                                                                                    }
                                                                                    checked={
                                                                                        (this.state.input.matchArr[item.id]
                                                                                        && this.state.input.matchArr[item.id] !== undefined
                                                                                        && Number(this.state.input.matchArr[item.id]) === Number(item.teamBId))
                                                                                        || (Number(this.state.input.matchBetArr[item.id]) === Number(item.teamBId))
                                                                                        ? 
                                                                                        true 
                                                                                        : 
                                                                                        false
                                                                                    }
                                                                                    // disabled={
                                                                                    //     (this.state.input.matchBetArr[item.id] || this.state.totalMatch[this.state.input.date].disabled)
                                                                                    //     ?
                                                                                    //     true
                                                                                    //     :
                                                                                    //     false
                                                                                    // }
                                                                                />
                                                                                <label className={`btn form-check-label ${(Number(item.teamBScore) < Number(item.teamAScore)) ? 'disabled' : ''}`} htmlFor={`matchOpt${item.teamBId}`}>
                                                                                    <img src={flag[`${item.teamB.toLowerCase()}.svg`]} alt={item.teamB} />
                                                                                    <p>{t(`world-cup.team.${item.teamB.toLowerCase()}`)}</p>
                                                                                </label>
                                                                                {(Number(item.teamBScore) > Number(item.teamAScore))
                                                                                // {((Number(item.teamBScore) > Number(item.teamAScore)) || ((Number(item.teamBExtraScore) > Number(item.teamAExtraScore))))
                                                                                ?
                                                                                    <img className="win-img" src={image["win.png"]} alt={`win${item.teamB}`} />
                                                                                :
                                                                                    null
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        {(item.teamAScore !== null && item.teamBScore !== null) &&
                                                                            <Confetti
                                                                                width={544}
                                                                                height={270}
                                                                                numberOfPieces={30}
                                                                                opacity={0.3}
                                                                            />
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </Fade>
                                                        </div>
                                                    );
                                                }
                                                else
                                                {
                                                    return null;
                                                }
                                            })}
                                        </div>}
                                        {(this.state.totalMatch[this.state.input.date] && !this.state.totalMatch[this.state.input.date].disabled)
                                        ?
                                            <Button
                                                typeButton={(localStorage.getItem("accessToken")) ? `submit` : `button`}
                                                classValue="btn btn-gradient-blue"
                                                buttonName={(localStorage.getItem("accessToken")) ? t('global.submit') : t("world-cup.login-to-submit")}
                                                clicked={(localStorage.getItem("accessToken")) ? null : () => this.props.history.push("/login")}
                                            />
                                        :
                                            null
                                        }
                                        {this.state.totalMatch[this.state.input.date] 
                                        && this.state.totalMatch[this.state.input.date].disabled 
                                        && this.state.totalMatch[this.state.input.date].totalWinCount > 0
                                        && 
                                            (<h4 className='result-text'>{t('world-cup.congrats-msg-3')}<span className='orange-text'>{this.state.totalMatch[this.state.input.date].totalWinCount}</span>{t('world-cup.congrats-msg-4')}</h4>)
                                        }
                                    </form>
                                </div>

                                <div className='section-header-gray mt-5'>
                                    <h2>{t('world-cup.title-3')}</h2>
                                    <p>{t('world-cup.title-4')}</p>
                                </div>
                                <div className='wc-vs-section'>
                                    <div className='wc-reward row gap-5'>
                                        {fakeData}
                                    </div>
                                    {(this.state.totalMatch[this.state.input.date] 
                                    && this.state.totalMatch[this.state.input.date].disabled 
                                    && this.state.totalMatch[this.state.input.date].totalWinCount > 0) 
                                    &&
                                        (<h4 className='result-text'>{t('world-cup.congrats-msg-3')}<span className='blue-text'>{this.state.totalMatch[this.state.input.date].totalWinCount}</span>{t('world-cup.congrats-msg-5')}<span className='orange-text'>{this.props.currentUser.currency}{this.state.totalMatch[this.state.input.date].totalWinAmt}</span></h4>)
                                    }
                                </div>

                                <div className='term-section mt-5'>
                                    <div className='term-container card-shadow'>
                                    <img src={tNc[`term-condition${imageLanguage}.svg`]} alt="Terms Condition" />
                                        <div className='term-content'>
                                            <h4 className='ps-4 '>{t('world-cup.title-5')}:</h4>
                                            <table className='table'>
                                                <thead>
                                                    <tr>
                                                        <th>{t('world-cup.guess', {attribute: 1})}</th>
                                                        <th>{t('world-cup.guess', {attribute: 2})}</th>
                                                        <th>{t('world-cup.guess', {attribute: 3})}</th>
                                                        <th>{t('world-cup.guess', {attribute: 4})}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>8</td>
                                                        <td>16</td>
                                                        <td>24</td>
                                                        <td>32</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <h4 className='ps-4 mt-3 mb-3'>{t('bet_and_earn.rule_of_activity')}：</h4>
                                            <ol>
                                                <li>{t('world-cup.rule-1')}</li>
                                                <li>{t('world-cup.rule-2')}</li>
                                                <li>{t('world-cup.rule-3')}</li>
                                                <li>{t('world-cup.rule-4')}</li>
                                                <li>{t('world-cup.rule-5')}</li>
                                                <li>{t('world-cup.rule-6')}</li>
                                                <li>{t('world-cup.rule-7')}</li>
                                                <li>{t('world-cup.rule-8')}</li>
                                                <li>{t('world-cup.rule-9')}</li>
                                                <li>{t('world-cup.rule-10')}</li>
                                                <li>{t('world-cup.rule-11')}</li>
                               </ol>
                                        </div>
                                                     <img src={tNc["term-footer.png"]} alt="Terms Condition footer" />
                                    </div>
                                </div>
                            </div>
                        </section>
                    ) : (
                        <MobileFifaWorldCup
                            {...this.state}
                            {...this.props}
                            changeDateHandler={this.changeDateHandler} 
                            getDuration={this.getDuration} 
                            onInputChangeHandler={(event) => this.onInputChangeHandler(event)}
                            mobileSlickHandler={this.mobileSlickHandler}
                            submitHandler={(event) => this.submitHandler(event)}
                            
                        />
                    )
                }
            </Auxiliary>
        )
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = (state) => 
{
    return {
        listing: state.fifaWorldCup.dropDown,
        store: state.fifaWorldCup.store,
        currentUser: state.currentUser.data,
    };
}

//Using the redux calling api methods
const mapDispatchToProps = (dispatch) => 
{
    return {
        funcGetDropDown: (leagueId) => dispatch(actions.getDropDown(leagueId)),
        funcStore: (data) => dispatch(actions.store(data)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(FifaWorldCup));